import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
export function elementsForSelectors(appContainer) {
  var selectors = Array.isArray(appContainer) ? appContainer : [appContainer];
  var elements = selectors.reduce(function (acc, selector) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(document.querySelectorAll(selector)));
  }, []);
  return elements;
}
export default elementsForSelectors;